import React, { useContext, useState } from "react";
import { Box, Grid, CardContent, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";

import { ContentWrapper } from "./style";
import Breadcrumb from "../../../../../Common/PageElements/Breadcrumb";
import SearchTable from "../../../../../../components/SearchTable";
import ToastContext from "../../../../../../util/toastContext";
import { GeneralTitlePage } from "../../SpecificProcurementNotice/style";
import { useQuery } from "react-query";
import { SummaryCard } from "./style";
import StaffTable from "./EvaluationTable";
import { getStaff } from "../../../../../../redux/reducer/adminReducer";
import EvaluationTab from "./EvaluationTab";
import receiptOfBiddersResponseApi from "../../../../../../redux/api/receiptOfBiddersResponseApi";

const TAB_VALUES = {
  PENDING: "pending",
  PASSED: "passed",
  FAILED: "failed"
};

const TechnicalReviews = () => {
  const [tabValue, setTabValue] = useState(TAB_VALUES.PENDING);
  const { showAlert } = useContext(ToastContext);
  const routeParams = useParams();
  const { procurementId } = routeParams;

  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  const { data: staffData = {}, isLoading } = useQuery({
    queryFn: receiptOfBiddersResponseApi.getEvaluatedVendors,
    queryKey: [
      "technical-evaluation",
      {
        pageSize: pagination.pageSize,
        pageNumber: pagination.pageNumber,
        procurementId,
        status: tabValue
      },
    ],
    config: {
      onError: (error) => showAlert({
        severity: "error",
        message: error?.message,
      })
    }
  });

  const { data: technicalReviewsStat = {} } = useQuery({
    queryFn: receiptOfBiddersResponseApi.getEvaluatedVendorsStat,
    queryKey: [
      "technical-evaluation-stat",
      { procurementId },
    ],
    config: {
      onError: (error) => showAlert({
        severity: "error",
        message: error?.message,
      })
    }
  });

  const rows = staffData?.data ?? [];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const updatePagination = (key) => (value) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      [key]: value,
    }));
  };

  const renderSummaryCards = () => {
    return (
      <Grid container spacing={2}>
        {getCardContents(technicalReviewsStat).map((item, index) => (
          <Grid item key={index}>
            <SummaryCard elevation={0}>
              <CardContent style={{ padding: "16px" }}>
                <Typography className="title" variant="body2" gutterBottom>{item.title}</Typography>
                <Typography className="count" variant="h6">{item.count}</Typography>
              </CardContent>
            </SummaryCard>
          </Grid>
        ))}
      </Grid>
    )
  }

  return (
    <ContentWrapper>
      <Box mt={3}>
        <GeneralTitlePage>Technical reviews</GeneralTitlePage>
        <Breadcrumb values={getBreadcrumbs(routeParams)} />
      </Box>

      <Box my={3}>
        {renderSummaryCards()}
      </Box>

      <SearchTable
        tabs={
          <EvaluationTab
            value={tabValue}
            handleChange={handleTabChange}
            tabs={[
              { value: TAB_VALUES.PENDING, label: "Pending Review" },
              { value: TAB_VALUES.PASSED, label: "Passed Technical" },
              { value: TAB_VALUES.FAILED, label: "Failed Technical" },
            ]}
          />
        }
        rows={rows}
        columns={["name", "quotation", "score", "remarks", ""]}
        tableAPI={getStaff}
        page={pagination.pageNumber}
        setPage={updatePagination("pageNumber")}
        rowsPerPage={pagination.pageSize}
        setRowsPerPage={updatePagination("pageSize")}
        loading={isLoading}
        totalNumberOfPages={staffData?.pagination?.totalEntries}
        empty={staffData?.pagination?.totalEntries === 0}
        emptyMessage="No technical review for any vendor"
      >
        <StaffTable staff={rows} />
      </SearchTable>
    </ContentWrapper>
  );
};

const getBreadcrumbs = ({ activityName, activityId, procurementId }) => ([
  {
    url: "/dashboard/overview",
    title: "Home",
  },
  {
    url: `/admin/procurement/plans`,
    title: "Plans",
  },
  {
    url: `/admin/procurement/activity/${activityName}/${activityId}/${procurementId}`,
    title: "Plan Details",
  },
  {
    url: `#`,
    title: "Technical Reviews",
  },
]);

const getCardContents = data => ([
  {
    title: "Pending Review",
    count: data.totalPending
  },
  {
    title: "Passed Technicals",
    count: data.totalPassed
  },
  {
    title: "Failed Technicals",
    count: data.totalFailed
  },
])

export default TechnicalReviews;
